import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Divider,
  Chip
} from '@mui/material';
import { formatarMoeda } from '../../../utils/formatters';
import PropTypes from 'prop-types';

const Confirmacao = ({ formData }) => {
  const totalPrestacoes = formData.prestacoes.reduce((acc, p) => acc + Number(p.valor), 0);
  const metodosAtivos = Object.entries(formData.metodosDisponiveisJSON)
    .filter(([key, value]) => value && !key.includes('_entidade'))
    .map(([key]) => key);

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Confirme os dados do plano de pagamento
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Informações Básicas
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography color="text.secondary">Ano Letivo</Typography>
                  <Typography variant="body1">{formData.anoLetivo}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography color="text.secondary">Valor Total</Typography>
                  <Typography variant="body1">{formatarMoeda(formData.valorTotal)}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography color="text.secondary">Descrição</Typography>
                  <Typography variant="body1">{formData.descricao}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography color="text.secondary">Data de Início</Typography>
                  <Typography variant="body1">
                    {new Date(formData.dataInicio).toLocaleDateString()}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography color="text.secondary">Data de Fim</Typography>
                  <Typography variant="body1">
                    {new Date(formData.dataFim).toLocaleDateString()}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
  <Typography color="text.secondary">Tipo de Plano</Typography>
  <Typography variant="body1">
    Base
    <Chip 
      size="small" 
      label="Template" 
      color="primary" 
      sx={{ ml: 1 }}
    />
  </Typography>
</Grid>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Prestações ({formData.prestacoes.length})
              </Typography>
              <Grid container spacing={2}>
                {formData.prestacoes.map((prestacao, index) => (
                  <Grid item xs={12} key={index}>
                    <Box sx={{ 
                      p: 2, 
                      border: 1, 
                      borderColor: 'divider',
                      borderRadius: 1,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <Box>
                        <Typography variant="subtitle2">{prestacao.mes}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          Vencimento: {new Date(prestacao.dataVencimento).toLocaleDateString()}
                        </Typography>
                      </Box>
                      <Typography variant="subtitle1">
                        {formatarMoeda(prestacao.valor)}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                    <Typography variant="subtitle1">Total das Prestações:</Typography>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {formatarMoeda(totalPrestacoes)}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Métodos de Pagamento
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                {metodosAtivos.map((metodo) => (
                  <Chip
                    key={metodo}
                    label={metodo}
                    color="primary"
                    variant="outlined"
                  />
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Regras de Multa
              </Typography>
              {formData.regrasMulta.map((regra, index) => (
                <Box key={index} sx={{ mb: 2 }}>
                  <Typography variant="subtitle2">
                    {regra.descricao}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {regra.percentualMulta}% após {regra.diasAtraso} dias
                  </Typography>
                  {index < formData.regrasMulta.length - 1 && <Divider sx={{ my: 1 }} />}
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

Confirmacao.propTypes = {
  formData: PropTypes.shape({
    anoLetivo: PropTypes.string,
    descricao: PropTypes.string,
    valorTotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dataInicio: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    dataFim: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    prestacoes: PropTypes.arrayOf(
      PropTypes.shape({
        mes: PropTypes.string,
        valor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        dataVencimento: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)])
      })
    ),
    regrasMulta: PropTypes.arrayOf(
      PropTypes.shape({
        diasAtraso: PropTypes.number,
        percentualMulta: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        descricao: PropTypes.string,
        tipo: PropTypes.string
      })
    ),
    metodosDisponiveisJSON: PropTypes.object
  }).isRequired
};




export default Confirmacao;